// extracted by mini-css-extract-plugin
export default {"backdrop":"TooltipMenu_backdrop__XNFCV","tolti_menu":"TooltipMenu_tolti_menu__d9e1T","bodygrow":"TooltipMenu_bodygrow__6hOWA","tipgrow":"TooltipMenu_tipgrow__sbbMl"};